export default {
  'AnalyticsCard.Wrapper': ({ isClickable }, outlet) => {
    if (!isClickable) return;
    outlet({})
  }
}